import { render, staticRenderFns } from "./PrivateDiscussionFacebook.vue?vue&type=template&id=1e0e011e&"
import script from "./PrivateDiscussionFacebook.vue?vue&type=script&lang=js&"
export * from "./PrivateDiscussionFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports